<div class="padding margin-top">
  <app-batches-filter></app-batches-filter>
  @if (repo.resource$ | async; as data) {
    <div class="table-container padding-top">
      @if (data) {
        <div class="table-container">
          @if (data.length > 0) {
            <table mat-table matSort [dataSource]="this.repo.resource$" multiTemplateDataRows class="mat-elevation-z0"
              (matSortChange)="sort($event)" [class.table-loading]="this.repo.loading$ | async"
              >
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.description' | transloco }} </th>
                <td mat-cell *matCellDef="let batch"> {{batch.description}} </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.type' | transloco }} </th>
                <td mat-cell *matCellDef="let batch"> {{ batch.batchType.id | enumLabel:'batchType':batch.batchType.name }} </td>
              </ng-container>
              <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.state' | transloco }} </th>
                <td mat-cell *matCellDef="let batch"> {{batch.batchState.name}} </td>
              </ng-container>
              <ng-container matColumnDef="added">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.added' | transloco }} </th>
                <td mat-cell *matCellDef="let batch"> {{batch.added | localizedDate:'yyyy-MM-dd'}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="navigateToBatch(row)"
                tabindex="0" (keydown.enter)="navigateToBatch(row)">
              </tr>
            </table>
          }
        </div>
      }
      @if (data && (this.repo.resourceCount$ | async) ?? 0 > 0) {
        <mat-paginator [pageSize]="this.repo.pageSize$ | async"
          [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
        [pageSizeOptions]="[10, 25, 50]" (page)="page($event)"></mat-paginator>
      }
      <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
    </div>
  }
</div>